import { Button, Dialog } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import { useNavigation, useSubmit } from "react-router";
import { FAVORITES_KEY } from "~/contexts/favorites.context";
import { clearAuthTelemetryFired } from "~/tooling/session/auth-telemetry-client-state";
import { captureEvent } from "~/tooling/telemetry/capture-event";
import {
	logoutSuccessEvent,
	userLoggedOutEvent,
	userResetEvent,
} from "~/tooling/telemetry/events";

interface LogoutModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export default function LogoutModal({ open, onOpenChange }: LogoutModalProps) {
	const { t } = useTranslation("auth");
	const navigation = useNavigation();
	const submit = useSubmit();

	const handleLogout = () => {
		captureEvent(userLoggedOutEvent());
		captureEvent(userResetEvent());
		captureEvent(logoutSuccessEvent());

		try {
			localStorage.removeItem(FAVORITES_KEY);
			clearAuthTelemetryFired();
		} catch {
			// Storage may be unavailable (e.g. Safari private mode)
		}

		submit({ redirectTo: "/" }, { method: "post", action: "/logout" });
	};

	return (
		<Dialog.Root open={open} onOpenChange={onOpenChange}>
			<Dialog.Content aria-describedby={undefined}>
				<Dialog.Title>{t("logout.title")}</Dialog.Title>
				<Dialog.Footer variant="vertical">
					<Button
						variant="primary"
						onClick={() => onOpenChange(false)}
						className="w-full"
						data-testid="logout-modal-no"
					>
						{t("logout.no")}
					</Button>
					<Button
						type="button"
						variant="secondary"
						onClick={handleLogout}
						pending={navigation.state !== "idle"}
						className="w-full"
						data-testid="logout-modal-yes"
					>
						{t("logout.yes")}
					</Button>
				</Dialog.Footer>
			</Dialog.Content>
		</Dialog.Root>
	);
}
